import { useRef } from 'react';
import { useReducedMotion } from 'framer-motion';
import { landingMode } from '../../../../../enums/landing';

// The niche the page speaks to (`?mode=`) and the copy it fills in: the title's
// highlighted topic, the niche the Studio learned from, who it writes for and where
// their reels go viral.
export default function useLanding(s) {
  const { t } = s;
  const scroller = useRef(null);
  const reduced = useReducedMotion();
  const locale = s.locale.replace('_', '-');
  const mode = landingMode(s.location.search);
  const copy = {
    topic: t(`landingTopic_${mode}`),
    field: t(`landingField_${mode}`),
    who: t(`landingWho_${mode}`),
    niche: t(`landingNiche_${mode}`),
  };
  // Sections rise in as they enter the page's own scroll.
  const reveal = { initial: { opacity: 0, y: 8 }, whileInView: { opacity: 1, y: 0 }, viewport: { root: scroller, once: true, amount: 'some' } };
  // The @ is the only way in: back to it from anywhere on the page.
  const start = () => {
    scroller.current?.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    scroller.current?.querySelector('.studio-handle input')?.focus({ preventScroll: true });
  };
  // A plan picked before sign-in waits in the entry; the Studio offers it once the
  // profile is ready (useStudio).
  const choose = plan => { s.updateEntry({ plan }); start(); };
  return { scroller, locale, mode, copy, reveal, start, choose };
}
